import type { GraphQLFormattedError } from 'graphql';
import { GRAPHQL_ERROR_CODES } from '@frameio/graphql-client/enums';
import { hasGraphQLErrorCode } from './hasGraphQLErrorCode';

type ErrorTypeMessageMap = {
  default: string;
  permissionDenied: string;
};

export const getOperationErrorMessage = (
  error: readonly GraphQLFormattedError[],
  messageMap: ErrorTypeMessageMap
) => {
  if (hasGraphQLErrorCode(error, GRAPHQL_ERROR_CODES.PERMISSION_DENIED)) {
    return messageMap.permissionDenied;
  }
  return messageMap.default;
};
